import { render } from "./spinner-with-overlay.vue?vue&type=template&id=5b13eb08&scoped=true"
import script from "./spinner-with-overlay.vue?vue&type=script&lang=js"
export * from "./spinner-with-overlay.vue?vue&type=script&lang=js"

import "./spinner-with-overlay.vue?vue&type=style&index=0&id=5b13eb08&scoped=true&lang=css"

import exportComponent from "/tmp/build_ed238492/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b13eb08"]])

export default __exports__